interface Currency {
  displayName: string;
  numericCode: number;
  defaultFractionDigits: number;
  subUnit: number;
  symbolSpaced: boolean;
  symbolPosition: "after" | "before";
  symbol: string;
  isoCode: "KHR";
};

const KHR: Currency = Object.freeze({
  "displayName": "Cambodian Riel",
  "numericCode": 116,
  "defaultFractionDigits": 0,
  "subUnit": 1,
  "symbolSpaced": true,
  "symbolPosition": "after",
  "isoCode": "KHR",
  "symbol": "៛"
});

export { KHR };
